var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[[_c('navigation-drawer'),_c('v-main',{staticClass:"main-page-content"},[_c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"the-content-component",attrs:{"id":"module"}},[_c('router-view',{key:_vm.$route.fullPath})],1)])],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }